// Ergebnis der Einladung per E-Mail je Adresse. inviteTalent wirft
// MAIL_NOT_SENT:<space_id>, wenn Talent und Person schon stehen, nur die Mail
// nicht rausging. Die ID steht in der Message, weil AppSync nur sie
// durchreicht. Das Dashboard schickt dann über space_id nach, statt ein
// zweites Talent anzulegen. Rein, ohne helpers/index.js.

const MAIL_NOT_SENT = /MAIL_NOT_SENT:([\w-]+)/

// Space-ID aus einem MAIL_NOT_SENT-Fehler, sonst null
export const mailNotSentSpaceId = (error) =>
  MAIL_NOT_SENT.exec(error?.message || '')?.[1] || null

// Ergebnis einer Adresse aus runWithConcurrency. space steht, wenn die Mail
// raus ist. unsentSpaceId steht, wenn das Talent angelegt ist und nur die Mail
// fehlt, auch nach einem gescheiterten Nachschicken.
export const inviteOutcome = (recipient, { value, reason }) => ({
  ...recipient,
  space: value || null,
  unsentSpaceId: value
    ? null
    : mailNotSentSpaceId(reason) || recipient.unsentSpaceId || null,
  error: reason
})

// Talente, die ein Durchgang neu angelegt hat, auch die ohne Mail.
// Nachgeschickte standen schon vorher und zählen nicht noch einmal.
export const newlyCreatedSpaces = (recipients, outcomes) =>
  outcomes.flatMap((outcome, index) => {
    if (recipients[index].unsentSpaceId) return []
    if (outcome.space) return [outcome.space]
    return outcome.unsentSpaceId ? [{ id: outcome.unsentSpaceId }] : []
  })

// Was „Erneut senden“ mit den Gescheiterten macht. Steht das Talent schon,
// geht nur die Mail über space_id nach. Ohne Space-ID gleicht die Talentliste
// ab, was trotz Fehler ankam (etwa nach einem Timeout), damit nichts doppelt
// rausgeht. Alle übrigen gehen erneut raus.
export const planRetry = (outcomes, spaceByEmail) => {
  const failed = outcomes.filter(({ space }) => !space)
  const arrived = new Map(
    failed
      .filter(({ unsentSpaceId }) => !unsentSpaceId)
      .map(({ email }) => [email, spaceByEmail.get(email)])
      .filter(([, found]) => found)
  )

  return {
    arrived,
    resend: failed.filter(({ email }) => !arrived.has(email))
  }
}
